import { ApiService } from "Services/ApiService";
import { EcommerceConfigDto, ResultsDTO } from "Types";

export const ConfigurationApiSlice = ApiService.injectEndpoints({
    endpoints: (builder) => ({
        getConfigurationByPlant: builder.query<EcommerceConfigDto, string>({
            query: (plant) => ({
                url: `ecomconfig/getbyplant/${plant}`,
            }),
            transformResponse: (response: ResultsDTO<EcommerceConfigDto>) => {
                const results = response.results;
                const isPromotionEnabledValue = (results.isPromotionEnabled ?? (results as any).isPromotion ?? 0) as 0 | 1;
                const isSellBooksEnabledValue = (results.isSellBooksEnabled ?? (results as any).isSellBook ?? 0) as 0 | 1;

                return {
                    ...results,
                    fast2SmsApiUrl: results.fast2SmsApiUrl ?? "",
                    delhiveryApiUrl: results.delhiveryApiUrl ?? "",
                    whatsappApiToken: results.whatsappApiToken ?? "",
                    whatsappApiUrl: results.whatsappApiUrl ?? "",
                    whatsappPhoneNumberId: results.whatsappPhoneNumberId ?? "",
                    isPromotionEnabled: isPromotionEnabledValue,
                    isSellBooksEnabled: isSellBooksEnabledValue,
                    isAuthor: (results.isAuthor ?? 0) as 0 | 1,
                    isLanguage: (results.isLanguage ?? 0) as 0 | 1,
                    isAcademic: (results.isAcademic ?? 0) as 0 | 1,
                    isMerchandise: (results.isMerchandise ?? 0) as 0 | 1,
                    isOffers: (results.isOffers ?? 0) as 0 | 1,
                    isEvents: (results.isEvents ?? 0) as 0 | 1,
                    isGlossary: (results.isGlossary ?? 0) as 0 | 1,
                    isHistory: (results.isHistory ?? 0) as 0 | 1,
                };
            },
            providesTags: [{ type: "Configuration", id: "LIST" }],
        }),

        updateConfiguration: builder.mutation<ResultsDTO, EcommerceConfigDto>({
            query: (config) => ({
                url: `ecomconfig/addorupdate`,
                method: "POST",
                body: {
                    ...config,
                    isPromotion: (config as any).isPromotionEnabled ?? (config as any).isPromotion ?? 0,
                    isSellBook: (config as any).isSellBooksEnabled ?? (config as any).isSellBook ?? 0,
                    isPromotionEnabled: (config as any).isPromotionEnabled ?? (config as any).isPromotion ?? 0,
                    isSellBooksEnabled: (config as any).isSellBooksEnabled ?? (config as any).isSellBook ?? 0,
                },
            }),
            invalidatesTags: [
                { type: "Configuration", id: "LIST" },
                // The sidebar (via useEcomConfig) reads the public config query,
                // which is tagged PUBLIC. Without invalidating it too, menu
                // visibility toggles only take effect after a full page refresh.
                { type: "Configuration", id: "PUBLIC" },
            ],
        }),
    }),
});

export const {
    useGetConfigurationByPlantQuery,
    useUpdateConfigurationMutation
} = ConfigurationApiSlice;
